export const JOB_RECOMMENDATION_STATUS = {
    PENDING: 'PENDING',
    EXPIRED: 'EXPIRED',
    REJECTED: 'REJECTED',
    ACCEPTED: 'ACCEPTED'
};
